import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useEntitlements } from '../../contexts/EntitlementsContext';

// Paths a company can still use with no subscription: manage the company,
// pick a plan, edit the profile. Everything else sends them to Subscription.
export const UNSUBSCRIBED_ALLOWED_PATHS = ['/subscription', '/my-company', '/profile'];

export const isAllowedWithoutSubscription = (pathname) => UNSUBSCRIBED_ALLOWED_PATHS
  .some((p) => pathname === p || pathname.startsWith(`${p}/`));

// Lock every nav item except the allowed ones. Locked items stay visible
// (they show what the company gets once it subscribes) but route to
// /subscription — AppShell already renders `locked` that way.
export const lockNavForUnsubscribed = (nav) => nav.map((group) => ({
  ...group,
  items: group.items.map((item) => (isAllowedWithoutSubscription(item.to) ? item : { ...item, locked: true })),
}));

// Route wrapper for the tenant shells. Until the entitlement snapshot has
// loaded it renders children (the server is the judge either way); once it
// says "no subscription", any page outside the allow-list redirects to
// /subscription so a new company lands on plan selection.
const SubscriptionGate = ({ children }) => {
  const { status, subscribed } = useEntitlements();
  const { pathname } = useLocation();
  const loaded = status === 'ready' || status === 'refreshing';
  if (loaded && !subscribed && !isAllowedWithoutSubscription(pathname)) {
    return <Navigate to="/subscription" replace />;
  }
  return children;
};

export default SubscriptionGate;
